// Module
var code = `<div class="svc-question__adorner">
  <div class="svc-question__content svc-question__content--in-popup">

    <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: templateData } } -->
    <!-- /ko -->

    <div class="svc-question__dropdown-choices">
      <!-- ko foreach: { data: question.visibleChoices, as: 'item' }  -->
      <div class="svc-question__dropdown-choice">
        <!-- ko component: { name: question.getItemValueWrapperComponentName(item), params: { componentData:  question.getItemValueWrapperComponentData(item), templateData: { name: 'survey-radiogroup-item', data: item } } } -->
        <!-- /ko -->
      </div>
      <!-- /ko -->
    </div>

  </div>
</div>`;
// Exports
export default code;